import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { CompanyUser } from "@/types";

/**
 * This hook is used to update a company user in the company users
 * for settings query without refetching the entire query.
 */
export const useSetCompanyUserInCompanyUsersForSettings = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyUserToSet }: { companyUserToSet: CompanyUser }) => {
    queryClient.setQueryData(
      ["settings/company-users", currentCompanyId],
      (cachedData: CompanyUser[]) => {
        return cachedData.map((companyUser) => {
          if (companyUser.email === companyUserToSet.email) {
            return companyUserToSet;
          }
          return companyUser;
        });
      },
    );
  };
};
